var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-upload"},[_c('file-pond',{attrs:{"name":_vm.name,"label-idle":_vm.idle,"accepted-file-types":_vm.accept,"allowFileEncode":true,"allow-multiple":_vm.allowMultiple,"files":_vm.rawFiles},on:{"updatefiles":_vm.updateFiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }